import React, { useState, useEffect } from 'react'
import { getDataWithoutClass,getDataWithClassId} from '../../../lib/studentinfoclassdetail'
import { addData, deleteFromData} from '../../../lib/classdetail'
//import { getDataWithClassforAdmin} from '../../../lib/classdetailview'
import { getIdData } from '../../../lib/classview'
import StudentBox from './studentbox'
import {  useParams } from 'react-router-dom'

export default function AdminStudentToClass() {
  //const [unSelectedStudent, setUnSelectedStudent] = useState([])
  //const [dumy, setDumy] = useState(true)

  const [allStudents, setAllStudents] = useState([])
  const [classStudent, setClassStudent] = useState([])
  //const [classes, setClasses] = useState([])
  const [classInfo, setClassInfo] = useState()

//  const navigate = useNavigate()
  let { slug } = useParams()

  async function GetStudentWithoutClass() {
    const profils = await getDataWithoutClass();
    if (profils.length > 0)
    setAllStudents(profils)
    console.log('setAllStudents', profils)
  }

  useEffect(() => {
    GetClassStudent()
    GetStudentWithoutClass()
  }, [])

  useEffect(() => {
    //setClassStudent([])
    //setUnSelectedStudent([])
    //GetClassData()
  }, [])

  async function GetClassStudent() {
    const classinf = await getIdData(slug)
    setClassInfo(classinf)
    const clas = await getDataWithClassId(slug)
    setClassStudent(clas)
    console.log('getDataWithClassforAdmin', clas)
  }
/*
  function GetClassData() {
    const copyprofile = [...allStudents]
    const temp = []
    classes.map((data) => {
      const defValue = copyprofile.filter((opt) => opt.id === data.studentId)
      copyprofile.splice(
        copyprofile.findIndex((e) => e.id === data.studentId),
        1
      )
      temp.push.apply(temp, defValue)
    })
    setUnSelectedStudent(copyprofile)
    setClassStudent(temp)
    //console.log('allStudents', allStudents)
    //console.log('copyprofile', copyprofile)
    //console.log('temp', temp)
  }
*/
  async function AddClassData(id) {
    await addData({
      classId: slug,
      instructorId: classInfo[0].instructorId,
      studentId: id
    })
    GetClassStudent()
    GetStudentWithoutClass()
  }

  async function RemoveClassData(id) {
    await deleteFromData({
      classId: slug,
      instructorId: classInfo[0].instructorId,
      studentId: id
    })
    GetClassStudent()
    GetStudentWithoutClass()
  }
/*
  function addToClass(id) {
    console.log('AddToClass', id)
    AddClassData(id)

    const copyprofile = [...unSelectedStudent]
    const temp = [...classStudent]

    const defValue = copyprofile.filter((opt) => opt.id === id)
    copyprofile.splice(
      copyprofile.findIndex((e) => e.id === id),
      1
    )
    temp.push.apply(temp, defValue)

    setUnSelectedStudent(copyprofile)
    setClassStudent(temp)

    /*

        const defValue = allStudents.filter(opt => opt.id === id);
        allStudents.splice(allStudents.findIndex(e => e.id === id), 1);

        const temp = [...classStudent, ...defValue];
        //temp.push(Object.assign({}, defValue));
        console.log("temp",temp);
        setClassStudent(temp);
*/
  //}
/*
  function removeToClass(id) {
    RemoveClassData(id)

    const copyprofile = [...unSelectedStudent]
    const temp = [...classStudent]

    const defValue = temp.filter((opt) => opt.id === id)

    temp.splice(
      temp.findIndex((e) => e.id === id),
      1
    )
    copyprofile.push.apply(copyprofile, defValue)

    setUnSelectedStudent(copyprofile)
    setClassStudent(temp)
    /*
        const defValue = classStudent.filter(opt => opt.id === id);

        classStudent.splice(classStudent.findIndex(e => e.id === id), 1);

        const temp = [...allStudents,...defValue];
        //profiles.push(defValue);
        setAllStudents(temp);
*/
  //}

  return (
    <div className='col-12'>
      <div className='row'>
        <div className='col-md-12'>
          <div className='settings-widget'>
            <div className='settings-inner-blk p-0'>
              <div className='sell-course-head comman-space'>
                <h3>Reviews</h3>
                <p>You have full control to manage your own account setting.</p>
              </div>
              <div className='comman-space pb-0'>
                <div className='instruct-search-blk mb-0'>
                  <div className='show-filter all-select-blk'>
                    <form action='#'>
                      <div className='row gx-2 align-items-center'>
                        <div className='col-md-6 col-lg-6 col-item '>
                          <div className='form-group select-form mb-1 '>
                            <label>Instructor</label>
                            <h4>
                              <b>
                                {classInfo
                                  ? classInfo[0].name +
                                    ' ' +
                                    classInfo[0].surname
                                  : ''}
                              </b>
                            </h4>
                          </div>
                        </div>
                        <div className='col-md-6 col-lg-6 col-item mr-2'>
                          <div className='form-group select-form mb-1'>
                            <label>Class</label>
                            <h4>
                              <b>{classInfo ? classInfo[0].class_name : ''}</b>
                            </h4>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
                <div className='row mt-2 gx-5'>
                  <div className='col border border-2 rounded-2 p-2'>
                    {allStudents.map(function (data, ix) {
                      return (
                        <div className='row' key={ix}>
                          <StudentBox data={data} />
                          <div className='col-xl-6 col-lg-6 col-md-6 '>
                            <div className='profile-share h-100 d-flex align-items-center justify-content-center'>
                              <button
                                type='button'
                                className='btn btn-success'
                                onClick={() => AddClassData(data.id)}
                              >
                                Add {'>>'}
                              </button>
                            </div>
                          </div>
                        </div>
                      )
                    })}
                  </div>
                  <div className='col'>
                    <div className='border border-2 rounded-2 p-2 h-100'>
                      {classStudent.length > 0
                        ? classStudent.map(function (data, ix) {
                            return (
                              <div className='row' key={ix}>
                                <div className='col-xl-6 col-lg-6 col-md-6 '>
                                  <div className='profile-share h-100 d-flex align-items-center justify-content-center'>
                                    <button
                                      type='button'
                                      className='btn btn-danger'
                                      onClick={() => RemoveClassData(data.id)}
                                    >
                                      {'<<'} Remove
                                    </button>
                                  </div>
                                </div>
                                <StudentBox data={data} />
                              </div>
                            )
                          })
                        : 'Empty Class'}
                      {/*}
                                                                <div ref={setNodeRef} style={droppablestyle}>
                                                                {classStudent.length >0 ? classStudent.map(function (cdata,ix) {
                                                            return (
                                                                    <StudentBox key= {ix} data={cdata[0]}/>
                                                            )
                                                        }) : "Drop Here"}
                                                                </div>
                                                    {*/}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
